import { createContext, useContext, useState, useCallback } from "react";
import { getMe } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("vendor_user") || "null");
    } catch {
      return null;
    }
  });
  const [vendor, setVendor] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("vendor_shop") || "null");
    } catch {
      return null;
    }
  });

  const login = useCallback((token, u) => {
    localStorage.setItem("vendor_token", token);
    localStorage.setItem("vendor_user", JSON.stringify(u));
    setUser(u);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("vendor_token");
    localStorage.removeItem("vendor_user");
    localStorage.removeItem("vendor_shop");
    setUser(null);
    setVendor(null);
  }, []);

  const refreshVendor = useCallback(async () => {
    const { data } = await getMe();
    if (data?.vendor) {
      setVendor(data.vendor);
      localStorage.setItem("vendor_shop", JSON.stringify(data.vendor));
    }
    if (data?.name) {
      const nu = { ...(JSON.parse(localStorage.getItem("vendor_user") || "{}")), name: data.name };
      setUser(nu);
    }
    return data;
  }, []);

  const patchVendorLocal = useCallback((patch) => {
    setVendor((v) => {
      const nv = { ...(v || {}), ...patch };
      localStorage.setItem("vendor_shop", JSON.stringify(nv));
      return nv;
    });
  }, []);

  const token = localStorage.getItem("vendor_token");

  return (
    <AuthCtx.Provider
      value={{ user, vendor, token, login, logout, refreshVendor, patchVendorLocal }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
